import React, { Component, PureComponent, Fragment } from 'react'
import { Icon } from 'semantic-ui-react'
import { connect } from 'react-redux'
import DataTable from '../datatable'
import { Map, List, fromJS } from 'immutable'
import { Link } from 'react-router-dom'
import TaskAdd from '~/task/views/add'
import TaskEdit from '~/task/views/edit'
import moment from 'moment'
import { fetchTaskTypes } from '~/taskType/actions'
import { statusOptions } from './views/form'
import Helmet from 'react-helmet'

let statusMap = {
  pending: 'Odottaa',
  working: 'Työn alla',
  done: 'Valmis',
}

const columns = [
  {
    name: 'task_type',
    label: 'Aihe',
    sortable: true,
    render: (i, column, { editTask }) => {
      let id = i.get('id')
      let status = i.get('status')
      let deadline = moment(i.get('deadline'), 'YYYY-MM-DD HH:mm:ss.SSSZZ')

      let statusColor = 'default'

      if (status === 'working') statusColor = 'info'

      if (status === 'completed') statusColor = 'success'

      let late = moment().isAfter(deadline)

      if (late && status !== 'completed') statusColor = 'error'

      let hasNote = !!i.getIn(['data', 'notes'], '').trim() && i.getIn(['data', 'notes']) !== '<p></p>'

      return (
        <Fragment>
          <span className={`status status--${statusColor}`} />
          <button className="button-plain" onClick={e => e.preventDefault() & editTask(id)}>
            {i.getIn(['data', '_task', 'icon']) ? <Icon name={i.getIn(['data', '_task', 'icon'])} /> : null}
            {i.getIn(['data', 'subject']) || i.getIn(['data', '_task', 'name']) || '(Tehtävän aihe puuttuu)'}
          </button>
          {hasNote && (
            <span className="tags" style={{ marginLeft: '6px' }}>
              <span className="tags-item tags-item--blue tags-item--icon" style={{ padding: '0 6px' }}>
                <Icon name="file" />
              </span>
            </span>
          )}
        </Fragment>
      )
    },
    export: i => {
      let subject = i.getIn(['data', 'subject']) || i.getIn(['data', '_task', 'name']) || '(Tehtävän aihe puuttuu)'
      return `${subject} (${i.get('status')})`
    },
  },
  {
    name: 'target',
    label: 'Kohde',
    render: i => {
      let targets = []
      let orderId = i.get('order_id')

      if (i.get('project_id'))
        targets.push(
          <Link
            to={`/project/${i.get('project_id')}/people`}
            className="tags-item tags-item--blue"
            key={i.get('project_id')}>
            {i.getIn(['project', 'name'])}
          </Link>
        )

      if (i.get('interview_id')) {
        targets.push(
          <span className="tags-item tags-item--blue tags-item--icon" key="interview-icon">
            <Icon name="angle right" />
          </span>
        )
        targets.push(
          <Link
            to={`/project/${i.get('project_id')}/interview/${i.get('interview_id')}`}
            className="tags-item tags-item--blue"
            key={i.get('interview_id')}>
            {i.getIn(['interview', 'name'])}
          </Link>
        )
      }

      if (i.get('order_id'))
        targets.push(
          <Link
            to={`/order?editId=${i.get('order_id')}&search=${encodeURIComponent(i.getIn(['order', 'name']))}`}
            className="tags-item tags-item--purple"
            key={i.get('order_id')}>
            <Icon name="file text" />
            {i.getIn(['order', 'name'])}
          </Link>
        )

      return <div className="tags">{targets}</div>
    },
    export: i => {
      let targets = []
      let orderId = i.get('order_id')

      if (i.get('project_id')) targets.push('Projekti: ' + i.getIn(['project', 'name']))

      if (i.get('interview_id')) {
        targets.push('Haastattelu: ' + i.getIn(['interview', 'name']))
      }

      if (i.get('order_id')) targets.push('Tilaus: ' + i.getIn(['order', 'name']))

      return targets.join(', ')
    },
  },
  {
    name: 'user',
    label: 'Vastuuhenkilö',
    sortable: true,
    render: i => i.getIn(['user', 'name'], '(Ei asetettu)'),
    export: i => i.getIn(['user', 'name'], '(Ei asetettu)'),
  },
  {
    name: 'deadline',
    label: 'Määräaika',
    sortable: true,
    defaultSort: true,
    date: true,
  },
]

/*
filters
defaultFilters={{user_id: user.id}}
filterFields={filterFields}
 */

class TaskRoot extends PureComponent {
  componentDidMount = () => {
    let { typesLoading, fetchTaskTypes } = this.props
    if (typesLoading) fetchTaskTypes()
  }

  render() {
    let { user, addTask, editTask, adding, editing, tasks, types, typesLoading } = this.props

    let editingTask = editing ? tasks.find(t => t.get('id') === editing) : false

    const filterFields = [
      {
        type: 'group',
        placeholder: 'Kohde',
        icon: 'cubes',
        fields: [
          {
            name: 'project_id',
            type: 'reference',
            label: 'Projekti',
            referenceConfig: {
              id: 'project',
              options: { source: 'project' },
            },
          },
          {
            name: 'interview_id',
            type: 'reference',
            label: 'Haastattelu',
            referenceConfig: {
              id: 'interview',
              options: { source: 'interview' },
            },
          },
          {
            name: 'order_id',
            type: 'reference',
            label: 'Tilaus',
            referenceConfig: {
              id: 'order',
              options: { source: 'order' },
            },
          },
        ],
      },
      {
        type: 'group',
        placeholder: 'Käyttäjä',
        icon: 'user',
        fields: [
          {
            name: 'user_id',
            type: 'reference',
            label: 'Käyttäjä',
            icon: 'user',
            referenceConfig: {
              id: 'user',
              options: { source: 'user' },
            },
          },
        ],
      },
      {
        type: 'group',
        placeholder: 'Tehtävät',
        icon: 'check',
        fields: [
          {
            name: 'task_type_id',
            type: 'checkboxes',
            label: 'Tehtävätyyppi',
            options: types
              .map(t => ({ value: t.get('id'), label: t.get('name'), icon: t.getIn(['data', 'icon'], 'check') }))
              .toArray(),
          },
        ],
      },
      {
        type: 'group',
        placeholder: 'Status',
        icon: 'check',
        fields: [
          {
            name: 'status',
            type: 'checkboxes',
            label: 'Status',
            options: statusOptions,
          },
        ],
      },
      {
        name: 'deadline',
        type: 'dates',
      },
    ]

    return (
      <Fragment>
        <DataTable
          id="tasks"
          entity="task"
          filters
          sortDir="asc"
          title="Tehtävät"
          actions={[{ text: 'Luo tehtävä', icon: 'plus', action: () => addTask() }]}
          filterFields={filterFields}
          context={{ editTask: id => editTask(id) }}
          columns={columns}
        />
        {editingTask ? (
          <TaskEdit task={editingTask} task_type_id="HJe9wtomQ" onClose={() => editTask(false)} />
        ) : adding ? (
          <TaskAdd onClose={() => addTask(false)} />
        ) : null}
      </Fragment>
    )
  }
}

function mapStateToProps(state) {
  return {
    types: state.taskTypes,
    typesLoading: state.taskTypesLoading,
    user: state.authUser || {},
    adding: state.rootTaskCreating,
    editing: state.rootTaskEditing,
    tasks: state.dataTable.getIn(['tasks', 'items'], List()),
  }
}

function mapDispatchToProps(dispatch) {
  return {
    addTask: (add = true) => dispatch({ type: 'ROOT_CREATE_TASK', add }),
    editTask: id => dispatch({ type: 'ROOT_EDIT_TASK', id }),
    fetchTaskTypes: () => dispatch(fetchTaskTypes()),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(TaskRoot)
